module.exports = __webpack_public_path__ + "img/noFireSYJ.5c343694.png";